"use strict";

/* VARS */
var previousPagination = [];
var bookSingelSliders = [];
var lastAction = '';
var searching;
var productSearch;
var firstLoad = true;

/* FUNCTIONS */
function hideModal (target) {

    if (target) {
        var modal;

        // Strip het minteken er af voor de verschillende tableoffers die we hebben en zo kunnen we herkennen of het om een tafelactie gaat
        var strippedTarget = target.split("-");

        switch(strippedTarget[0]) {
            case 'return':
            case 'warning':
                modal = $('[data-popover="' + target + '"]');
                modal.remove();
                break;
            case 'scan':
            case 'search':
            case 'orders':
                // Vangt popovers af binnen het gedeelte van de retouren voor boekgoed
                modal = $('[data-popup="popup-' + strippedTarget[0] + '"]');

                if (!modal.hasClass('hide')) {
                    // functie staat gedefinieerd op app niveau van boekgoed
                    clearPopup(modal);
                }
                break;
            case 'tableoffer':
                modal = $('[data-popover="' + target + '"]');

                if (!modal.hasClass('hide')) {
                    modal.removeClass('show');
                    modal.addClass('hide');
                    resetTableOffer(modal);
                }
                break;
            case 'address':
                modal = $('[data-hook="address-popup-container"]');
                modal.removeClass('edit-active');
                modal.removeClass('show');
                modal.addClass('hide');
            case 'request':
                modal = $('[data-hook="request-login-popup-container"]');
                modal.removeClass('show');
                modal.addClass('hide');
            default:
        }

    }
}

function showWarning (title, message, target, url) {
    if (typeof url !== 'undefined') {
        // Uitgebreidere modal voor nu ten behoeve van het verlaten van het retour creatie proces
        var modal =
        `<div class="modal hide" data-popover="warning"
            data-hook="bundle-container"
            data-itemtype="bundle"
            data-bundletype="return">
            <div class="warning-modal retour">
                <div class="modal-text">
                ${message}
                </div>
                <div class="modal-footer bg-blue">
                    <div class="modal-footer-cancel">
                        <button class="btn bg-red" data-close="popover" data-target="warning" data-hotkey="escape">
                            Nee, ik ga verder met deze retourzending
                        </button>
                        <a href="${url}" class="btn bg-orange" data-close="popover" data-target="warning">
                            Ja, verwijder deze selectie
                        </a>
                    </div>
                </div>
            </div>
            <div class="dark-background" data-close="popover" data-target="warning"></div>
        </div>`;
    } else {
        var modal =
        `<div class="modal hide" data-popover="warning"
            data-hook="bundle-container"
            data-itemtype="bundle"
            data-bundletype="return">
            <div class="warning-modal">
                <div class="modal-header">
                    <h3 class="return-title">${title}</h3>
                    <div class="close-modal" data-close="popover" data-target="warning">
                        <i class="icon-cancel"></i>
                    </div>
                </div>
                <div class="modal-text">
                ${message}
                </div>
                <div class="modal-footer bg-blue">
                    <div class="modal-footer-cancel">
                        <button class="btn bg-red" data-close="popover" data-target="warning" data-hotkey="escape">
                            Venster sluiten
                        </button>
                    </div>
                </div>
            </div>
            <div class="dark-background" data-close="popover" data-target="warning"></div>
        </div>`;
    }



    // Injecteer de modal in de dom en toon deze
    $(target).after(modal);
    $('[data-popover="warning"]').removeClass('hide');
    $('[data-popover="warning"]').addClass('show');
}

function formatPrice (price, type) {
    if (type == 'simple') {
        var formattedPrice = '€ ' + price;
    } else {
        if (price == 0) {
            var formattedPrice = '€ 0';

        } else {
            var splitPrice = String(price).split('.');
            var suffix = splitPrice[1] ? splitPrice[1] : '00';
            suffix = suffix.substring(0,2);

            if (suffix.length == 1) {
                var formattedPrice = '€ ' + splitPrice[0] + ',' + suffix + '0';
            } else {
                var formattedPrice = '€ ' + splitPrice[0] + ',' + suffix;
            }
        }
    }

    return formattedPrice;
}

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

function mobileSliders() {
    if(isBelowMd()) {
        $('.book-single-slider').each(function(index, element) {
            $(this).addClass('swiper-book-single-index-'+index);
            var duplicates = $(this).find('.swiper-slide').length;
            var slider = new Swiper('.swiper-book-single-index-'+index, {
                direction: 'horizontal',
                slidesPerView: 'auto',
                nextButton: '.slick-next',
                prevButton: '.slick-prev',
                onInit: function(slider) {
                    setNavigation(slider, '.book-cover-container');
                }
            });
            bookSingelSliders.push(slider);
        });
    } else {
        if(bookSingelSliders) {
            for (var i = 0; i < bookSingelSliders.length; i++) {
                bookSingelSliders[i].container.find('.slick-arrow').hide();
                bookSingelSliders[i].destroy(true, true);
            }
            bookSingelSliders = [];
        }
    }
}

function checkParameter(field) {
    var url = window.location.href;
    if(url.indexOf('?' + field + '=') != -1) {
        return true;
    }
    else if(url.indexOf('&' + field + '=') != -1) {
        return true;
    }
    return false
}

function scrollToSuggestions() {
    var top = $('.home-welcome').offset().top;
    var navbarHeight = $('.nav-main').height();

    $('html, body').animate({
        scrollTop: (top-navbarHeight)
    }, 800);
}

function setNavigation(slider, coverElement) {
    var arrowHeight = slider.container.find(coverElement).height()/2;
    slider.container.find('.glyphicon-chevron-right').css({'top' : arrowHeight});
    slider.container.find('.glyphicon-chevron-left').css({'top' : arrowHeight});
    slider.container.find('.slick-arrow').show();
}

function makeid() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 10; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}
function checkIfKeyIsSet(searchParamsKey) {
    var key = searchParamsKey;
    var urlPath = window.location.href;
    var substring = "#filter:";
    var URLKey;
    if(urlPath.indexOf(substring) !== -1) {
        urlPath = urlPath.split(substring);
        URLKey = urlPath[urlPath.length - 1]
    }
    if(URLKey == key) {
        return true;
    } else {
        return false;
    }
}
function fillSearchParams(searchParams) {
    if(searchParams.params) {
        var key = searchParams.key;
        if(checkIfKeyIsSet(key)) {
            var params = JSON.parse(searchParams.params);
            for (var property in params) {
                if (params.hasOwnProperty(property)) {
                    //Checkboxes aanvinken
                    if(typeof params[property] == 'object') {
                        for (var i = 0; i < params[property].length; i++) {
                            var subCategory = $('input[type="checkbox"][value="'+params[property][i]+'"][name*="'+property+'"]');
                            if(subCategory.closest('label').hasClass('has-children')) {
                                subCategory.closest('label').find('.category-list-expand').removeClass('foldin').addClass('foldout');
                                $('[data-parent="'+params[property][i]+'"]').removeClass('hide');
                            }
                            subCategory.prop("checked", true);
                        }
                    }
                    //In geval van subcategorieën, deze ook active maken onder de titel
                    switch(property) {
                        case 'subCategories':
                            //Wanneer all categorieën gechecked zijn, alles unchecken (zou beide alles moeten tonen)
                            var amountSubCats = $('input[type="checkbox"][name*="'+property+'"]').length;
                            var amountChecked = $('input[type="checkbox"][name*="'+property+'"]:checked').length;
                            if(amountChecked == amountSubCats) {
                                $('input[type="checkbox"][name*="'+property+'"]').prop("checked", false);
                                $('[data-parent]').addClass('hide');
                            } else {
                                //Subcategorieën onder hoofdcategorie titel actief zetten
                                for (var i = 0; i < params[property].length; i++) {
                                    $('.category-subcategory-links [data-category-id="'+params[property][i]+'"]').addClass('active');
                                }
                            }
                            //Check maken voor subcategorieën, als deze alleen geselecteerd zijn , geen vinkjes aan zetten
                            for (var i = 0; i < params[property].length; i++) {
                                var hasSubSubs = $('[name="subCategories"][value="'+params[property][i]+'"]').closest('.subcategory-label').hasClass('has-children');
                                if(hasSubSubs) {
                                    var subSubCatContainer = $('[data-parent="'+params[property][i]+'"]');
                                    var checked = subSubCatContainer.find('[name="subCategories"]:checked');
                                    var totalSubSubs = subSubCatContainer.find('[name="subCategories"]');
                                    if(checked.length == totalSubSubs.length) {
                                        totalSubSubs.prop("checked", false);
                                    }
                                }
                            }
                        break;
                        case 'price':
                            var sliderValue1,
                            sliderValue2;
                            if(params[property][0]) {
                                sliderValue1 = params[property][0];
                            } else {
                                //@todo deze waarde nog dynamisch op laten halen op basis van html waarde
                                sliderValue1 = '0';
                            }
                            if(params[property][1]) {
                                sliderValue2 = params[property][1];
                            } else {
                                //@todo deze waarde nog dynamisch op laten halen op basis van html waarde
                                sliderValue2 = '55';
                            }
                            $("#ex2").attr('data-slider-value', '['+sliderValue1+','+sliderValue2+']');
                            $("#ex2").attr('value', sliderValue1+','+sliderValue2);
                        break;
                    }
                }
            }
            productSearch.setAdditionalParams(params);
        }
    }
}

function animateBookToCart(covers) {
    for (var i = 0; i < covers.length; i++) {
        var cart = $('.nav-cart'),
            bookImage = covers[i],
            cartPosition = cart.offset(),
            imageWidth = bookImage.width(),
            imageHeight = bookImage.height(),
            imagePosition = bookImage.offset(),
            cloneImage = bookImage.clone(),
            horizontalDistance = imagePosition.left-cartPosition.left,
            verticalDistance = (imagePosition.top-cartPosition.top),
            animationContainer = $('<div class="animation-container"></div>');

        animationContainer.append(cloneImage);
        $('body').append(animationContainer);
        $('body').addClass('animating-cart');
        animationContainer.addClass('move-to-cart');
        animationContainer.css({'top' : (imagePosition.top-$(window).scrollTop())+'px', 'left' : imagePosition.left + 'px'});
        cloneImage.css({'width' : imageWidth+'px', 'height' : imageHeight+'px'});
        cloneImage.addClass('rounded-small');
        animationContainer.animate({
            top: "-="+verticalDistance+'px',
            left: "-="+horizontalDistance+'px',
        });
        cloneImage.removeClass('book-image');
        cloneImage.addClass('scale-cart');

        function removeAnimation() {
            cart.addClass('item-received');
            animationContainer.remove();
            //Zorgen dat class enkel verwijderd wordt wanneer er geen animerende items op de pagina zijn
            if($('.move-to-cart').length < 1) {
                $('body').removeClass('animating-cart');
            }
        }
        //Functionaliteit werkt niet in ie9, maar moet vervangen worden door Ajax reactie call
        //Toegevoegd animatie element weer verwijderen
        cloneImage.on('animationend', function() {
            removeAnimation();
        });
    }
}
function convertPriceStringToNumber(price) {
    var price = price.replace(/,/g, '.');
    return parseFloat(price);
}
function convertNumberToPriceString(price) {
    var price = parseFloat(Math.round(price * 100) / 100).toFixed(2);
        price = price+'';
        price = price.replace('.', ',');
    return price;
}
function addItemToCart(data) {
    var productData = [];
    var updateData = [];
    var bookId;

    $.each(data, function (key, book) {
        bookId = book.itemId;
        productData[bookId] = {
            "bookCover" : book.covers,
            "inStock" : book.stock,
            "author" : book.auteurs,
            "title" : book.title,
            "itemtype" : book.itemType,
            "categoryButton" : book.categoryButton,
            "state" : book.state,
            "model" : book.model
        };

        updateData.push({
            "action"    : "add",
            "amount"    : book.amount,
            "itemType"  : book.itemType,
            "itemId"    : bookId,
            "state"     : book.state
        });
    });

    updateCartBackend(updateData, productData);
}

function setTotalItems(total) {
    if ($('[data-hook="checkout-book-count"]').length > 0) {
        // Als we op de checkout pagina zijn wordt het afgehandeld in doc-secondary van die view
    } else {
        $('[data-hook="cart-amount"]').html(total);
    }
}
function showModalMessage(title, message) {
    var modal = ' \
            <div id="informVoidedVoucher" class="modal fade" tabindex="-1" role="dialog"> \
              <div class="modal-dialog" role="document">  \
                <div class="modal-content"> \
                  <div class="modal-header"> \
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> \
                    <h4 class="modal-title">'+title+'</h4> \
                  </div> \
                  <div class="modal-body"> \
                    '+message+' \
                  </div> \
                  <div class="modal-footer"> \
                    <button type="button" class="btn rounded-small bg-mediumBlue" data-dismiss="modal">Ok</button> \
                  </div> \
                </div><!-- /.modal-content --> \
              </div><!-- /.modal-dialog --> \
            </div><!-- /.modal -->';
        modal = $(modal);
    $('body').append(modal);
    $('#informVoidedVoucher').modal('show');
    modal.on('hidden.bs.modal', function () {
        modal.remove();
    });
}
//Update data heeft 3 veree istproperties en 1 optionele
//updateData.action
//updateData.itemType
//updateData.itemId
//updateData.amount

function emptyCartBackend() {
    lastAction = 'cartEmpty';
    $.ajax({
        method: "POST",
        url: "/cart/empty"
    }).done(function( feedback ) {
        if(feedback.success == 1) {
            emptyCartFrontend();
        } else {
            console.log(feedback);
        }
    });
}

function emptyCartFrontend() {
    var body = $('[data-hook="cart-items"]');

    // Gooit de cart-items container leeg.
    body.empty();

    $('[data-hook="cart-amount"]').html(0);

    // Injecteer dummy content voor later gebruik - Momenteel staat dit globaal op App niveau in boekgoed in de header gedefinieerd. @TODO rewrite
    body.html(dummyRow);

    cartStateHandler();
}

function cartStateHandler() {
    // Als het winkelmandje leeg is moet hij anders worden opgemaakt dan als er items in zitten.
    if($('[data-hook="cart-amount"]').html() == 0) {
        $('[data-hook="empty-cart-message"]').removeClass('hide');
        $('[data-hook="filled-cart-data"]').addClass('hide');
    } else {
        $('[data-hook="empty-cart-message"]').addClass('hide');
        $('[data-hook="filled-cart-data"]').removeClass('hide');
    }
}

function updateCartBackend(updateData, productData) {
    lastAction = 'cartUpdate';
    $.ajax({
        method: "POST",
        url: "/cart/update",
        data: {
            "items" : updateData
        }
    }).done(function( feedback ) {
        if(feedback.success == 1) {
            var data = {
                "feedback": feedback
            }
            if(productData) {
                data.productData = productData;
            }
            updateCartFrontEnd(data);
        } else {
            console.log(feedback);
        }
    });
}

function updateCartFrontEnd(data) {
    var changedItems = data.feedback.cartComparison.itemsFrontend;
    var changedActions = data.feedback.cartComparison.actionCategoryItems;
    var totalPriceSell = data.feedback.totalPriceSell;
    var totalPriceWithoutShippingSell = data.feedback.totalPriceWithoutShippingSell;
    var totalPriceWithoutShippingRetail = data.feedback.totalPriceWithoutShippingRetail;
    var totalPriceRetail = data.feedback.totalPriceRetail;
    var totalBookCount = data.feedback.amount;
    var upsellSuggestions = data.feedback.upsellSuggestions;
    var totalDiscount = data.feedback.totalDiscount;
    var voucherVoid = data.feedback.voucherVoid;

    setTotalItems(totalBookCount);

    if(voucherVoid  && lastAction != 'removeVoucher') {
        var title = 'Kortingscode vervallen';
        var message = '<p>Uw bestelling voldoet niet meer aan de eisen van de kortingscode.</p> \
                    <p>De kortingscode is komen te vervallen.</p>';

        showModalMessage(title, message);
    }

    function addActionCategory(actionCategory, target) {
        var exists = target.find('[data-category-name="'+actionCategory.name+'"]');
        if(exists.length < 1) {
            var button = '<div data-category-name="'+actionCategory.name+'" class="cart-action-granted"> \
                            <div class="category-button '+actionCategory.class+' shadow-soft"> \
                                <p> \
                                    <strong class="larger-font">'+actionCategory.buttonText[0]+'</strong> \
                                    '+actionCategory.buttonText[1]+' \
                                </p> \
                                <div class="category-button-border"></div> \
                            </div> \
                        </div>';
            var target = target.find('[data-hook="action-granted"]');
            if(target.length > 0) {
                target.html(button);
            }
        }
    }
    function editCartRowsDropdown(rows, type) {


        var tbody;
        if(type == 'actions') {
            tbody = $('[data-hook="cart-actions"]');
        } else {
            tbody = $('[data-hook="cart-items"]');
        }
        for (var i = 0; i < rows.length; i++) {
            var itemType = rows[i].cartItem.itemType;
            var actionCategory = rows[i].actionCategory;
            switch(rows[i].type) {
                case 'added':
                    //CARTDROPDOWN ------------- //
                    //Cartitem template bepalen
                    var cartItemTemplate;
                    var cartItemExists = $('[data-hook="cart-items"]').find('[data-cart-rowid="'+rows[i].cartRowId+'"]');
                    //Kijken of cartRow al bestaat, zo ja, op basis daarvan kopie maken
                    if(cartItemExists.length > 0) {
                        cartItemTemplate = cartItemExists;
                    } else {
                        cartItemTemplate = tbody.find('[data-cart-rowid]').first();
                    }
                    if(!cartItemTemplate.hasClass('hide')) {
                        cartItemTemplate = cartItemTemplate.clone();
                        tbody.append(cartItemTemplate);
                    }

                    cartItemTemplate.find('.cart-item-cover img').attr('src', rows[i].cartItem.itemData.urlCover);
                    if(rows[i].cartItem.itemData.actionCategoryButton) {
                        var button = $(rows[i].cartItem.itemData.actionCategoryButton);
                        /* HACK nog uit zoeken waarom functie zonder setTimeout niet goed werkt */
                        setTimeout(function(){
                            cartItemTemplate.find('.cart-item-cover .relative').append(button);
                        }, 0);
                    }
                    cartItemTemplate.attr('data-cart-stock', rows[i].cartItem.itemData.inStock);
                    cartItemTemplate.attr('data-cart-itemtype', rows[i].cartItem.itemType);
                    cartItemTemplate.find('.cart-item-author').html(rows[i].cartItem.itemData.authors);
                    cartItemTemplate.find('.cart-item-title').html(rows[i].cartItem.itemData.title);
                    cartItemTemplate.find('[data-hook="cart-state"]').html(rows[i].cartItem.itemData.state);
                    cartItemTemplate.find('.category-button, .cart-action-granted').remove();

                    //Cartitem van juiste properties voorzien
                    cartItemTemplate.attr({
                        'data-cart-rowid': rows[i].cartRowId,
                        'data-cart-itemid': rows[i].cartItem.itemId,
                        'data-cart-itemtype': itemType
                    });

                    if(itemType == 'campaign') {
                        var actionCategoryName = rows[i].actionCategory.description;
                        cartItemTemplate.find('.cart-item-title').html(actionCategoryName);
                    }

                    //Prijs zetten
                    cartItemTemplate.find('[data-hook="cart-item-price"]').attr('data-cart-pricefor', rows[i].priceSell).html(rows[i].priceSell);
                    if(type == 'actions') {
                        cartItemTemplate.find('[data-hook="cart-item-count"]').hide().val(rows[i].amount);
                    } else {
                        cartItemTemplate.find('[data-hook="cart-item-count"]').show().val(rows[i].amount);
                    }

                    if (rows[i].cartItem.itemData.priceSell == '0,00') {
                        cartItemTemplate.find('[data-hook="amount-and-trash"] > span').hide();
                    } else {
                        cartItemTemplate.find('[data-hook="amount-and-trash"] > span').show();
                    }

                    var target = tbody.find('[data-cart-rowid="'+rows[i].cartRowId+'"]');
                    if(actionCategory) {
                        addActionCategory(actionCategory, target);
                    }
                    else {
                        target.find('[data-hook="action-granted"]').empty();
                    }

                    //Indien cartTemplate origineel een hidden laag was, deze class verwijderen
                    cartItemTemplate.removeClass('hide');
                break;

                case 'changed':
                    var tableRow = tbody.find('[data-cart-rowid="'+rows[i].cartRowId+'"]');
                    var priceFor = rows[i].priceFor;
                    var actionCategory = rows[i].actionCategory;

                    //Mutaties op dropdown cart doorvoeren
                    if(actionCategory) {
                        addActionCategory(actionCategory, tableRow);
                    }
                    else {
                        tableRow.find('[data-hook="action-granted"]').html('');
                    }
                    //data.productData misbruiken om te kijken of change call vanuit item toevoegen komt, of vanuitcijfer aanpassen in cart
                    if(type == 'actions' || data.productData) {
                        tableRow.find('[data-hook="cart-item-count"]').val(rows[i].amount);
                    }
                    tableRow.find('[data-hook="cart-item-price"]').html(priceFor);

                break;

                case 'removed':
                    //Mutaties op dropdown cart doorvoeren
                    var item = tbody.find('[data-cart-rowid="'+rows[i].cartRowId+'"]');
                    if(tbody.find('[data-cart-rowid]').length > 1) {
                        //Als item niet laatste in het mandje is, item van pagina verwijderen
                        item.remove();
                    } else {
                        //Wanneer item laatste in mandje is, op hide zetten en aantal op 0 ipv removen om dummy data beschikbaar te houden voor nieuwe items
                        item.find('[data-hook="cart-item-count"]').val(0);
                        item.attr('data-cart-rowid', '');
                        item.find('input[type="number"]').prop('disabled', false);
                        item.addClass('hide');
                    }
                break;
            }
        }
    }

    function editUpsellSuggestions(suggestions) {
        //Vorige resultaten clearen
        //@todo vergelijk functie maken zodat items die blijven staan niet eerst verwijderd worden en opnieuw geplaatst worden
        //$('[data-hook="suggestions-actions-dropdown"]').empty();
        var timeouts = [];
        var completeHTML = '';
        for (var i = 0; i < suggestions.length; i++) {
            var popoverTimeout;
            var achieved;
            var glyphicon;
            if(suggestions[i].achievedInCart) {
                achieved = 'granted';
                glyphicon = 'ok';
            } else {
                achieved = 'suggested';
                glyphicon = 'arrow-right';
            }
            var exists = $('#suggestion-'+suggestions[i].campaignName);
            var popover = false;
            if(exists.length > 0) {
                //Wanneer upsell suggestie al bestaat, maar status veranderd, popover tonen
                if(!exists.hasClass('suggestion-action-'+achieved)) {
                    popover = true;
                }
            } else {
                //Bij nieuwe upsell suggestie, popover tonen
                popover = true;
            }
            var suggestionHTML = ' \
                    <div id="suggestion-'+suggestions[i].campaignName+'" class="cart-suggestion-action clearfix suggestion-action-'+achieved+'"> \
                        <div class="cart-suggestion-action-granted"> \
                            <i class="glyphicon glyphicon-'+glyphicon+'"></i> \
                        </div> \
                        <div class="cart-suggestion-action-description"> \
                            '+suggestions[i].description+' \
                        </div> \
                    </div>';
            if(popover) {
                if($('#popoverContainer').length < 1) {
                    $('<div id="popoverContainer" class="popoverContainer"><span class="rounded-small shadow-soft"></span></div>').insertAfter('[data-hook="header-cart"]');
                }
                var popoverContainer = $('#popoverContainer');
                var showPopover = $(suggestionHTML).clone();
                showPopover.attr('id','');
                popoverContainer.find('span').append(showPopover);
                removePopover(showPopover);
            }
            completeHTML = completeHTML+suggestionHTML;
        }
        function removePopover(popover) {
            setTimeout(function() {
                popover.fadeOut(300, function() {
                    $(this).remove();
                });
                $('#popoverContainer').fadeOut(300, function() {
                    $(this).remove()
                });
            }, 3500);
        }
        $('[data-hook="suggestions-actions-dropdown"]').empty();
        $('[data-hook="suggestions-actions-dropdown"]').append(completeHTML);
    }

    //Actions eerst verwerken zodat laatste row die blijft staan altijd een item is
    editCartRowsDropdown(changedActions, 'actions');
    editCartRowsDropdown(changedItems, 'items');

    if(upsellSuggestions)
        editUpsellSuggestions(upsellSuggestions);

    $('.nav-cart-total-price').find('[data-hook="cart-total-pricefrom"]').html(totalPriceRetail);
    $('.nav-cart-total-price').find('[data-hook="cart-total-pricefrom-subtotal"]').html(totalPriceWithoutShippingRetail);
    $('.nav-cart-total-price').find('[data-hook="cart-total-pricefor"]').html(totalPriceSell);
    $('.nav-cart-total-price').find('[data-hook="cart-total-pricefor-subtotal"]').html(totalPriceWithoutShippingSell);
    $('.cart-discount-total').find('[data-hook="cart-discount-total"]').html(totalDiscount);

    if(totalDiscount == '0,00') {
        $('.cart-discount-total').addClass('hide');
    } else {
        $('.cart-discount-total').removeClass('hide');
    }

    /* Controleren of pagina checkout open staat, indien ja, ook daarfrontend acties doorvoeren */
    if (typeof updateCartFrontEndCheckout === "function") {
        updateCartFrontEndCheckout(data);
    }

    //Controleren of de table in het dropdown winkelmandje op mobile mag scrollen of niet
    if(isBelowMd)
        handleScrollingTable();

    //Bericht tonen/hiden dat Cart leeg is
    cartStateHandler();
}
//Kijken of device resolutie lager is dan bootstrap md resolutie
function isBelowMd() {
    if ($(window).width() < 975) {
        return true;
    } else {
        return false
    }
}
function isBelowSm() {
    if ($(window).width() <= 500 &&  767) {
        return true;
    } else if($(window).width() > 768 < 991){
        return false
    } 
}
function isTouch() {
    if($('body').hasClass('hover-only')) {
        return false;
    } else {
        return true;
    }
}
//Jquery plugin die detecteerd of element een scrollbar heeft of niet
(function($) {
    $.fn.hasScrollBar = function() {
        return this.get(0).scrollHeight > this.height();
    }
})(jQuery);
function handleScrollingTable() {
    var $scroller = $("#scrollableTable");
    $scroller.unbind("touchmove");
    if($scroller.hasScrollBar()) {
        //Zorgen dat je wel kan blijven scrollen binnen de table met shoppingcart items
        $($scroller).on('touchmove', function (e) {
            e.stopPropagation();
        });
        //Zorgen dat scrollableTable niet alsnog de body kan scrollen wanneer deze ana zijn top of bottom zit
        $scroller.bind('touchstart', function (ev) {
            var $this = $(this);
            var scroller = $scroller.get(0);

            if ($this.scrollTop() === 0) $this.scrollTop(1);
            var scrollTop = scroller.scrollTop;
            var scrollHeight = scroller.scrollHeight;
            var offsetHeight = scroller.offsetHeight;
            var contentHeight = scrollHeight - offsetHeight;
            if (contentHeight == scrollTop) $this.scrollTop(scrollTop-1);
        });
    } else {
        $scroller.bind("touchmove", function(e){
            e.preventDefault();
        });
    }
}

function checkFixed(e) {
    if (!isBelowMd()) {
        var topHeight = document.getElementsByClassName('nav-top')[0].clientHeight;
        if (document.body.scrollTop > topHeight || document.documentElement.scrollTop > topHeight) {
            $('.nav-container').addClass('nav-container-fixed');
        } else {
            $('.nav-container').removeClass('nav-container-fixed');
        }
    }
    else {
        $('.nav-container').removeClass('nav-container-fixed');
    }
}
function submitSearch() {
    var searchParameter = $('[data-hook="top-search"]').val();
    if(searchParameter.length > 0) {
        // @todo zoekresultaten dynamisch ophalen uit docs
        window.location.href = '/zoekresultaten/'+searchParameter;
    }
}
function removeAdditionalParams() {
    searchParams = null;
    productSearch.setAdditionalParams({});
}
function changePagination(pageNumber, tab) {
    if(tab == 'product' || tab == 'newInStock' || tab == 'searchResults' || tab == 'publisher')  {
        removeAdditionalParams();
    }
    var currentActive = $('[data-table="'+tab+'"] [data-hook="pagination"]').find('.active');
    previousPagination.push(currentActive.attr('data-page'));
    currentActive.removeClass('active');
    //Kijken of element bestaat, anders op de pagina plaatsen
    if($('[data-table="'+tab+'"] [data-page="'+pageNumber+'"]').length > 0) {
        $('[data-table="'+tab+'"] [data-page="'+pageNumber+'"]').addClass('active');
    } else {
        $('[data-table="'+tab+'"] .pagination').append('<li class="active hide" data-hook="page" data-page="'+pageNumber+'">'+pageNumber+'</li>');
    }
    var top;
    if(isBelowMd()) {
        if($('[data-hook="product-container"]').length > 0) {
            top = $('[data-hook="product-container"]').position().top-($('.nav-container').height()+$('.nav-search').height());
        } else if($('[data-hook="search-result-products"]').length > 0) {
            top = $('[data-hook="search-result-products"]').position().top-($('.nav-container').height()+$('.nav-search').height());
        }
    } else {
        top = $('[data-hook="table-control"]:visible').position().top-($('.nav-main').height());
    }
    firstLoad = false;
    switch(tab) {
        case 'author':
            authorSearch.search();
            break;
        case 'category':
            categorySearch.search();
            break;
        default:
            productSearch.search();
    }
    $('html, body').animate({
        scrollTop: top
    }, 300);
}
function resetPagination() {
    productSearch.setAdditionalParams({page:1});
    $('[data-hook="pagination"]').find('.active').removeClass('active');
    $('[data-page="1"]').addClass('active');
}

function deleteCartRow(cartRowId) {
    var bookRowNav = $('.nav-cart-dropdown').find('[data-cart-rowid="'+cartRowId+'"]');
    var updateData = []

    updateData.push({
        "action"    : "delete",
        "cartRowId"    : bookRowNav.attr('data-cart-rowid')
    });
    updateCartBackend(updateData);
}
function confirmDeleteProduct(cartRowId) {
    if(readAlwaysDelete) {
        deleteCartRow(cartRowId);
    } else {
        var modal = ' \
                <div id="confirmDelete" class="modal fade" tabindex="-1" role="dialog"> \
                  <div class="modal-dialog" role="document">  \
                    <div class="modal-content"> \
                      <div class="modal-header"> \
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> \
                        <h4 class="modal-title">Product verwijderen</h4> \
                      </div> \
                      <div class="modal-body"> \
                        <p>Weet u zeker dat u dit product wilt verwijderen?</p> \
                      </div> \
                      <div class="modal-footer"> \
                        <button type="button" class="btn rounded-small bg-red" data-dismiss="modal">Nee</button> \
                        <button type="button" class="btn rounded-small bg-orange" data-hook="confirm-delete">Ja</button> <br> \
                        <label>Niet opnieuw vragen <input type="checkbox" data-hook="always-delete"></label> \
                      </div> \
                    </div><!-- /.modal-content --> \
                  </div><!-- /.modal-dialog --> \
                </div><!-- /.modal -->';
            modal = $(modal);
        $('body').append(modal);
        $('#confirmDelete').modal('show');
        $('[data-hook="always-delete"]').on('change', function() {
            var alwaysDelete;
            if($(this).is(':checked')) {
                alwaysDelete = true;
            } else {
                alwaysDelete = false;
            }
            $.ajax({
                method: "POST",
                url: "/cart/saveDeletePreference",
                data: { "alwaysDelete" : alwaysDelete }
            })
            .done(function( data ) {
                readAlwaysDelete = data.alwaysDelete;
            })
            .fail(function( error ) {
                console.log(error);
            });
        });
        modal.on('hidden.bs.modal', function () {
            modal.remove();
        });
        $('[data-hook="confirm-delete"]').click( function() {
            $('#confirmDelete').modal('hide');
            deleteCartRow(cartRowId);
        });
    }
}

function confirmEmptyCart() {
    var modal = ' \
            <div id="confirmEmptyCart" class="modal fade" tabindex="-1" role="dialog"> \
                <div class="modal-dialog" role="document">  \
                <div class="modal-content"> \
                    <div class="modal-header"> \
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> \
                    <h4 class="modal-title">Winkelmand leegmaken</h4> \
                    </div> \
                    <div class="modal-body"> \
                    <p>Weet u zeker dat u alle producten uit uw winkelmand wilt halen?</p> \
                    </div> \
                    <div class="modal-footer"> \
                    <button type="button" class="btn rounded-small bg-red" data-dismiss="modal">Nee</button> \
                    <button type="button" class="btn rounded-small bg-orange" data-hook="confirm-empty">Ja</button> <br> \
                    </div> \
                </div><!-- /.modal-content --> \
                </div><!-- /.modal-dialog --> \
            </div><!-- /.modal -->';
        modal = $(modal);

    $('body').append(modal);
    $('#confirmEmptyCart').modal('show');

    modal.on('hidden.bs.modal', function () {
        modal.remove();
    });

    $('[data-hook="confirm-empty"]').click( function() {
        $('#confirmEmptyCart').modal('hide');
        emptyCartBackend();
    });
}

function validateSettings() {
    var validateSettings = {
        lang: 'nl',
        rules : {
            'emailAddress': {
                'email': true,
                required: true
            }
        },
        errorPlacement: function(error, element) {
            element.parent().find('label.error, label.success').remove();
            error.insertAfter(element);
        }
    }
    return validateSettings;
}

function prepareAddToCart(e) {
    var itemContainer = $(this).closest('.item-container');
    var itemType = $(itemContainer).attr('data-itemtype');
    var bookData = [];
    var books = [];

    switch (itemType) {
        case 'product':
            $('.book-hoverable-clicked').removeClass('book-hoverable-clicked');
            books = [itemContainer];
            break;
        case 'bundle':
            var bundleType = $(itemContainer).attr('data-bundletype');
            books = itemContainer.find('[data-hook="book-cover-container"]');

            switch (bundleType) {
                case 'tableoffer':
                    break;
                default:
                    // bundle type not recognised
                    break;
            }
            break;
        default:
            // item type is not defined
            break;
    }

    var covers = [];
    $.each (books, function ( key, book) {
        var cover = $(book).find('[data-hook="book-image"]:visible');
        if(isBelowMd()) {
            cover = $(book).find('[data-hook="book-image"]:visible:not(#zoom-image)');
        }
        covers.push(cover);

        bookData[key] = {
            "itemId": $(book).attr('data-id'),
            "itemType": $(book).attr('data-itemtype'),
            "amount": $(book).attr('data-amount'),
            "stock": $(book).attr('data-cart-stock'),
            "covers": covers,
            "title": $(book).attr('data-title'),
            "auteurs": $(book).attr('data-author'),
            "categoryButton": $(book).find('.category-button'),
            "state": $(book).attr('data-state'),
            "model": $(book).attr('data-model'),
        };

        var checkCart = $('[data-cart-itemid="'+bookData.id+'"]');
        var outOfStock = false;

        if(checkCart.length > 0) {
            var currentAmount = checkCart.find('[data-hook="cart-item-count"]').val();
            if(parseInt(currentAmount) >= parseInt(bookData.stock)) {
                outOfStock = true;
                showModalMessage(
                    'Product voorraad bereikt!',
                    '<p>De voorraad van dit product is onvoldoende deze actie te voltooien.</p><p>U kunt van dit product maximaal <strong>'+bookData.stock+'</strong> stuk(s) bestellen.</p>'
                );
            }
        }
    });
    if(itemType === 'bundle') {
        animateBookToCart([itemContainer.find('[data-hook="add-cart"]')]);
    } else {
        animateBookToCart(covers);
    }

    addItemToCart(bookData);
}

function checkAddressPopup() {
    var popupContainer = $('[data-hook="address-popup-container"]');

    var postalCode = popupContainer.find('[name="User[address][postalCode]"]').val().replace(new RegExp(' ', 'g'), '');  // postcode zonder spaties
    var number = popupContainer.find('[name="User[address][number]"]').val();
    var numberSuffix = popupContainer.find('[name="User[address][numberSuffix]"]').val();
    var countryId = popupContainer.find('[name="User[address][countryId]"]').val();

    if (countryId == 148 && postalCode.length == 6 && number.length >= 1) {
        $.ajax({
            type: 'POST',
            url: '/checkout/checkAddress',
            data: {
                postalCode: postalCode,
                number: number,
                numberSuffix: numberSuffix
            },
            dataType: 'json',
            success: function(data, textStatus, xhr) {
                if (data.success == 1) {
                    if(data.address.street) {
                        popupContainer.find('[name="User[address][street]"]').val(data.address.street);
                    }
                    if(data.address.city) {
                        popupContainer.find('[name="User[address][city]"]').val(data.address.city);
                    }
                }
            },
            error: function(data, textStatus, xhr) {
                console.log("error");
                console.log(data);
            }
        });
    }
}



function toggleLanguageSelectionForSearchResults(e) {
    e.preventDefault();

    //Bij filter wijziging, paginering resetten
    resetPagination();
    clearTimeout(searching);
    //Search kleine timeout geven om dubbele slider input te voorkomen
    searching = setTimeout(
        function() {
            firstLoad = false;
            productSearch.search();
        }, 100
    );
}

function skipSeoPageContent(e) {
    e.preventDefault();

    let btn = $(this);
    let offset = 0;
    if (btn.hasClass('skip-button-bottom')) {
        offset = -500;
    }

    $("html, body").animate({scrollTop: ($(btn.attr("href")).offset().top + offset)}, 500);
}


/* LISTENERS */
$('body').on('click', '.tab-container .sorting-tab', toggleLanguageSelectionForSearchResults);
$('body').on('click', '.button-container a.skip-button', skipSeoPageContent);

/** EXECUTE */
$( document ).ready(function() {

    window.addEventListener('touchstart', function() {
        $('body').removeClass('hover-only');
    });

    window.addEventListener("scroll", checkFixed);

    $(window).resize(function() {
        mobileSliders();
        checkFixed();
    });

    $('[data-hook="submit-newsletter-email"], [data-hook="submit-newsletter-email-mobile"], [data-hook="submit-newsletter-email-home"]').on('submit', function(e) {
        var that = $(this);
        var emailAddress = $(this).find('input').val();
        var newsletterData = {
            'newsletterEmail' : emailAddress
        }
        $.ajax({
            method: "POST",
            url: "/newsletter/subscribe",
            data: newsletterData
        }).done(function( feedback ) {
            if(feedback.success == 1) {
                that.find('label.error, label.success').remove();
                if(feedback.message) {
                    var message = '<label class="success">'+feedback.message+'</label>';
                    that.find('input').val('');
                    $(message).insertAfter(that.find('input'));
                }
            } else {
                if(feedback.message) {
                    var message = '<label class="error">'+feedback.message+'</label>';
                    $(message).insertAfter(that.find('input'));
                }
            }

        });
        e.preventDefault();
    });
    $('[data-hook="submit-newsletter-email"]').validate(validateSettings());
    $('[data-hook="submit-newsletter-email-mobile"]').validate(validateSettings());
    $('[data-hook="submit-newsletter-email-home"]').validate(validateSettings());

    //Zorgen dat categories blijven staan op mobile click
    $('[data-hook="nav-category-dropdown"]').click(function() {
        if(isBelowMd() || isTouch()) {
            $('.nav-categories-dropdown').toggleClass('clicked');
        }
    });

    //Active status voor tabbladen
    $(".sorting-tab").click(function () {
        $(".sorting-tab").removeClass("active-sorting-tab");
        $(this).addClass("active-sorting-tab");   
    });

    

    //Categories uitklappen wanneer over category knop ge-hoverd wordt
    var categoryHover;
    $('[data-hook="nav-category-dropdown"]').hover(
        function() {
            if(!isBelowMd() && !isTouch()) {
                clearTimeout(categoryHover);
                $('.nav-categories-dropdown').addClass('clicked');
            }
        }, function() {
            if(!isBelowMd() && !isTouch()) {
                categoryHover = setTimeout(
                    function(){
                        $('.nav-categories-dropdown').removeClass('clicked');
                    },
                    500
                );
            }
        }
    );

    $('.nav-categories-headitem').click(function() {
        $('.nav-categories-headitem').removeClass('clicked');
        if(isBelowMd()) {
            $(this).toggleClass('clicked');
        }
    });

    //Zorgen dat hoverable states blijven staan met een click
    $('body').on('click', '.book-hoverable', function(e) {
        //Hover class niet toevoegen wanneer op add-cart gedrukt wordt
        if(
            $(e.target).attr('data-hook') != "add-cart" &&
            $(e.target).attr('data-hook') != "step-up" &&
            $(e.target).attr('data-hook') != "step-down" &&
            $(e.target).attr('data-hook') != "cart-item-count" &&
            $(e.target).attr('data-hook') != "view-more"
            ) {
                var el = this;
                $('.book-hoverable').not(el).removeClass('book-hoverable-clicked');
                var par = el.parentNode;
                var next = el.nextSibling;
                // HACK Removechild ge-deactiveerd, JS toevoegen van product aan winkelmandje werkte niet meer
                //par.removeChild(el);
                setTimeout( function() {
                    par.insertBefore(el, next);
                }, 0);
                $(this).toggleClass('book-hoverable-clicked');
            }
    });

    //Show more knop daadwerkelijk data laten tonen
    $('body').on('click', '[data-hook="show-more"]', function() {
        var status = $(this).attr('data-show-status');
        var target = $(this).attr('data-show-target');
        if(status == 'hidden') {
            $(this).attr('data-show-status', 'visible');
            $('#'+target).removeClass('hide');
            $(this).html('Toon minder');
        } else {
            $(this).attr('data-show-status', 'hidden');
            $('#'+target).addClass('hide');
            $(this).html('Toon meer');
        }
    });

    $('[data-hook="empty-cart"]').on('click', function() {
        confirmEmptyCart();
    });

    //Items aan cart toevoegen wanneer op "toevoegen" geklikt wordt
    $('body').on('click', '[data-hook="add-cart"]', prepareAddToCart);
    //Bundels aan cart toevoegen wanneer op "toevoegen" geklikt wordt
    /*$('body').on('click', '[data-hook="add-cart-bundel"]', function() {
        var bundle = $(this).closest('[data-hook="bundel-container"]');
        var covers = [];
        var titles = [];
        var authors =[];
        bundle.find('[data-hook="bundle-book-image"]:visible').each(function(){
            covers.push($(this));
        });
        bundle.find('[data-hook="bundle-book-title"]').each(function(){
            titles.push($(this).html());
        });
        bundle.find('[data-hook="bundle-book-author"]').each(function(){
            authors.push($(this).html());
        });
        var bundelData = {
            "id": bundle.attr('data-id'),
            "covers": covers,
            "titles": titles,
            "auteurs": authors,
            "itemType": bundle.attr('data-itemtype')
        };
        animateBookToCart(covers);
        var updateData = {
            "action"    : "add",
            "itemType"  : bundelData.itemType,
            "itemId"    : bundelData.id
        };
        addItemToCart(bundelData);

        //updateCartBackend(updateData);
    });*/
    //Aanpassingen doorvoeren wanneer aantal in winkelmandje gewijzigd wordt
    $('body').on('change', '[data-hook="cart-item-count"]', function() {
        // @todo selector specifieker maken wanneer regel opgesplitst worden door gebruik actie categorieen
        // Data-context fallback er in verwerkt voor boekgoed, inline elementen gebruiken ook data-hook cart-item-count @TODO kijken naar afscheiding
        if ($(this).attr('data-context') !== 'inline' && $(this).attr('data-context') !== 'tableoffer') {

            var cartRowId = $(this).closest($('[data-cart-rowid]')).attr('data-cart-rowid');
            var bookRowNav = $('.nav-cart-dropdown').find('[data-cart-rowid="'+cartRowId+'"]');
            var bookRowBody = $('.cart-overview').find('[data-cart-rowid="'+cartRowId+'"]');


            var price = bookRowNav.find('[data-cart-pricefor]').attr('data-cart-pricefor');
            var amount = $(this).val();

            if(amount <= 0) {
                var confirm = confirmDeleteProduct(cartRowId);
                $(this).val(1);
                amount = 1;
            }

            var productData = {
                "bookCover" : bookRowNav.find('[data-hook="cart-item-cover"]').attr('src'),
                "author" : bookRowNav.find('[data-hook="cart-item-author"]').html(),
                "state" : bookRowNav.find('[data-hook="cart-item-state"]').html(),
                "title" : bookRowNav.find('[data-hook="cart-item-title"]').html(),
                "itemtype" : bookRowNav.attr('data-cart-itemtype')
            }

            //Controleren of item wel zo vaak besteld kan worden
            var inStock = $(this).closest('[data-cart-stock]').attr('data-cart-stock');
            if(parseInt(amount) > parseInt(inStock)) {
                amount = inStock;
                $(this).val(amount);
                var msg = '<p>U bestelling overtreft het aantal dat wij op voorraad hebben.</p> <p>Wij hebben van dit product nog <strong>'+amount+'</strong> stuk(s) op voorraad.</p>  <p>Uw bestelling is aangepast.</p>';
                showModalMessage('Bestelling aangepast!', msg);
            }

            var updateData = []
            updateData.push({
                "action"    : "update",
                "cartRowId"    : bookRowNav.attr('data-cart-rowid'),
                "amount"    : amount
            });

            updateCartBackend(updateData);
        }
    });


    //Aanpassingen doorvoeren wanneer volledig product uit winkelmandje verwijderd wordt
    $('body').on('click touchend', '[data-hook="cart-item-remove"]', function() {
        var cartRowId = $(this).closest($('[data-cart-rowid]')).attr('data-cart-rowid');
        var confirm = confirmDeleteProduct(cartRowId);
    });

    $('[data-hook="header-cart"]').on('animationend', function() {
        $(this).removeClass('item-received');
    });
    //Winkelmandje uitklappen wanneer over mandje ge-hoverd wordt
    var cartHover;
    $('[data-hook="header-cart"]').hover(
        function() {
            if(!isBelowMd() && !isTouch()) {
                clearTimeout(cartHover);
                $('.nav-cart-dropdown').addClass('cart-hover');
            }
        }, function() {
            if(!isBelowMd() && !isTouch()) {
                cartHover = setTimeout(
                    function(){
                        $('.nav-cart-dropdown').removeClass('cart-hover');
                    },
                    500
                );
            }
        }
    );

    //Winkelmandje uitgeklapt laten wanneer op mandje geklikt wordt
    $('[data-hook="header-cart"]').click(function() {
        //Voor mobile uitklappen
        if(isBelowMd() || isTouch()) {
            $('html, body').animate({
                scrollTop: (0)
            }, 100);
            $('.nav-cart-dropdown').toggleClass('cart-clicked');
            $('body').toggleClass('cart-open');
            //Scrollen op mobile voor body in/uitschakelen bij uit/inklappen van winkelmandje
            if($('body').hasClass('cart-open')) {
                $(document).bind("touchmove", function(e){
                    e.preventDefault();
                });
                handleScrollingTable();
            } else {
                $(document).unbind("touchmove");
            }
            //Onderste deel van de cart de hoogte van de navbar omhoog zetten zodat deze perfect onderin komt te staan
            var navHeight = $('.nav-container').height();
            $('.cart-mobile-bottom').css({'marginBottom' : (navHeight-1)+'px'});
        } else {
        //Voor desktop naar cart navigeren
            window.location.href = '/checkout';
        }
    });
    //Voor de checkout pagina's naar eerste stap van checout laten gaan
    $('[data-hook="header-cart-click-only"]').click(function() {
        window.location.href = '/checkout';
    });
    //Winkelmandje inklappen wanneer ergens anders op de pagina geklikt wordt (werkt enkel op mobile)
    /*$('body').click(function(e) {
        if (isBelowMd() && $(e.target).closest('[data-hook="header-cart"]').length === 0 && $(e.target).closest('[data-hook="cart-items"]').length === 0 && $(e.target).closest('[data-hook="add-cart"]').length === 0) {
            $('.nav-cart-dropdown').removeClass('cart-clicked');
            $('body').removeClass('cart-open');
        }
    });*/
    //Uitgeklapte elementen inklappen
    $(document).bind('click', function(e) {
        if($(e.target).closest('.nav-categories-dropdown').length === 0 && $(e.target).closest('[data-hook="nav-category-dropdown"]').length === 0) {
            $('.nav-categories-dropdown').removeClass('clicked');
        }
        if($(e.target).closest('.nav-cart').length === 0 && $(e.target).closest('.nav-cart-dropdown').length === 0) {
            $('.nav-cart-dropdown').removeClass('cart-clicked');
        }
    });
    $('[data-hook="top-search"]').on('keyup', function (e) {
        if (e.keyCode == 13) {
            submitSearch();
        }
    });
    $('[data-hook="top-search-submit"]').on('click', function(){
        submitSearch();
    });
    $('[data-hook="back-button"]').click( function() {
        if (typeof goBackUrl != 'undefined') {
            window.location.href = goBackUrl;
            return;
        }

        var urlPath = window.location.href;
        var substring = "#filter:";
        //Kijken of filters gezet zijn
        if(urlPath.indexOf(substring) !== -1) {
            //Kijken of paginering gezet is
            if(previousPagination.length > 0) {
                var previousPage = previousPagination[previousPagination.length - 1];
                changePagination(previousPage);
                previousPagination.splice(-2,2);
            } else {
                window.history.go(-2);
            }
        } else {
            window.history.go(-1);
        }
    });

    $('body').on('click','[data-hook="navLoginButton"]', function(e) {
        e.preventDefault();

        var gotoUrl = $(this).attr('href');
        var redirectUrl = window.location.href;

        $('[data-hook="navLoginForm"]').attr('action', gotoUrl);
        $('[data-hook="navLoginFormRedirectUrl"]').val(redirectUrl);
        $('[data-hook="navLoginForm"]').submit();
    });

    $('[data-hook="show-filters"]').click(function() {
        $('.sidebar').toggleClass('sidebar-slideout');
        $('.nav-search').toggleClass('hidden-xs');
    });

    $('[data-hook="close-filters"]').click( function() {
        $('.sidebar').removeClass('sidebar-slideout');
        $('.nav-search').removeClass('hidden-xs');
    });

    var lastScrollTop = 0;
    var navSearch = $('.nav-search');
    var scrollTimeout;
   /* $(window).scroll(function(event) {
        clearTimeout(scrollTimeout);
        if(isBelowMd()) {

            scrollTimeout = setTimeout( function() {
                var st = $(this).scrollTop();
                if (st > lastScrollTop && st > $('.nav-container').height()) {
                    if(navSearch.is(':visible'))
                        $('.nav-search').slideUp(200);
                } else {
                    if(!navSearch.is(':visible'))
                        $('.nav-search').slideDown(200);
                }
                lastScrollTop = st;
            }, 100);

        } else {
            if(!$('.nav-search').is(':visible')) {
                $('.nav-search').show();
            }
        }
    });*/

    /*$('.book-single-slider-always-slide, .book-single-slider, .selection-slider').on('init', function(a, b, c) {
        var arrowHeight = $(this).find('.book-cover-container').height()/2;
        $(this).find('.glyphicon-chevron-right').css({'top' : arrowHeight});
        $(this).find('.glyphicon-chevron-left').css({'top' : arrowHeight});
    });
    $('.topsold').on('init', function(a, b, c) {
        var arrowHeight = $(this).find('.topsold-book').height()/2;
        $(this).find('.glyphicon-chevron-right').css({'top' : arrowHeight});
        $(this).find('.glyphicon-chevron-left').css({'top' : arrowHeight});
    });*/


/* EXECUTE */
    window.onload = function() {
        if($('#ex2').length > 0) {
            //Price range slider initieren
            $("#ex2").slider({
                tooltip: 'always',
                tooltip_split: true,
                tooltip_position:'bottom'
            });
        }
        if($('#ageRange').length > 0) {
            //Price range slider initieren
            $("#ageRange").slider({
                tooltip: 'always',
                tooltip_split: true,
                tooltip_position:'bottom'
            });
        }
    };

    //Tooltips initieren
    $(document).ready(function() {
        $('[data-toggle="tooltip"]').tooltip();
        var autoComplete = new AutoCompleteSearch(
            '/search/auto-complete',
            '[data-hook="top-search"]',
            '[data-hook="top-search-result"]',
            autoCompleteHitProcessors,
            autoCompleteHitTemplates
        );
        autoComplete.setCategories(autoCompleteCategories);

        checkFixed();
        mobileSliders();
    });

    $('body').on('click', '[data-hook="open-popover"]', function() {
        var target = $(this).attr('data-target');
        var popover = $('[data-popover="' + target + '"]');

        if (target == 'return') {
            // Scrape de tablerow waarin alle data attributen voor de return staan
            handleReturnPopover($(this).closest('[data-verified]'));
        } else {
            popover.removeClass('hide');
            popover.addClass('show');
        }
    });

    $('body').on('click', '[data-close="popover"]', function() {
        var target = $(this).attr('data-target');
        hideModal(target);
    });

    $('body').on(
        'keyup',
        'input[name="User[address][postalCode]"], input[name="User[address][number]"], input[name="User[address][numberSuffix]"]',
        checkAddressPopup
    );

    $(document).keydown(function(event) {
        if (event.keyCode == 27) {
            $('[data-hotkey="escape"]').each(function( index, element ) {
                var target = $(this).attr('data-target');
                hideModal(target);
            });
        }
    });
});